// extracted by mini-css-extract-plugin
export default {"cookieConsent":"styles_cookieConsent__UJWhy","hidden":"styles_hidden__yuOJm","textWrapper":"styles_textWrapper__7HrlO","accent":"styles_accent__dRxmZ","bold":"styles_bold__UYtCL"};